import {
  arrayToColumnVector,
  createMatrix,
  solveLinearSystem,
  sumColumn,
} from './matrix.js';

function calculateProfit({ matrix }) {
  const matrixObj = createMatrix(matrix);
  const onesVector = arrayToColumnVector(Array(matrixObj.rows()).fill(1));
  const solution = solveLinearSystem(matrixObj, onesVector);
  return solution ? 1 / sumColumn(solution) : 0;
}

export function profit(matrix) {
  const result = calculateProfit({ matrix });
  return result;
}
